import { ref as i } from "vue";
import n from "../store/apis/marketplace.api-es.js";
const c = i(void 0), a = i(void 0), o = (r) => new Promise((t) => {
  n.getSiteAlert(r).then((s) => {
    const e = s.data ?? {};
    if (Object.keys(e).length !== 0) {
      const l = {
        alertLink: e.termsText ?? null,
        alertUrl: e.termsURL ?? null,
        alertMessage: e.text ?? null,
        alertTitle: e.title ?? null
      };
      c.value = l || c.value;
    }
  }).catch(() => {
    t();
  }), t();
}), k = (r) => new Promise((t) => {
  n.getKickbackAlerts(r).then((s) => {
    const e = s.data ?? {};
    if (Object.keys(e).length !== 0) {
      const l = {
        errors: e.errors ?? [],
        results: e.results ?? []
      };
      a.value = l.results || a.value;
    }
  }).catch(() => {
    t();
  }), t();
}), g = (r, t) => ({
  getSiteAlert: o(r),
  getKickbackAlerts: k(t),
  siteAlert: c,
  kickbackAlerts: a
});
export {
  g as default
};
//# sourceMappingURL=useSiteAlert-es.js.map
